
import { Component, Vue, Prop } from 'vue-property-decorator';
import { UpdateEntry, UpdateType, UpdateTypeDescriptions } from 'ah-api-gateways';

@Component
export default class UpdateEntryCard extends Vue {
  @Prop({ required: true }) update!: UpdateEntry;

  get UpdateType() {
    return UpdateType;
  }

  get UpdateTypeDescriptions() {
    return UpdateTypeDescriptions;
  }
}
